import { createSlice } from '@reduxjs/toolkit';
import { flow } from 'fp-ts/function';
import { BOOKING_RESTARTED } from '../../../modules/global/actionTypes';
import { CLEAR_TIMES } from '../../../modules/resourceOrder/actionTypes';
import { ApplicationState } from '../../../types';
import { moduleId } from '../constants';

export const CALENDAR_SLICE_NAME = 'calendarConfiguration';

const calendarInitialState: ApplicationState[typeof moduleId][typeof CALENDAR_SLICE_NAME] = {
    areDatesVisible: false,
    areTimesSelected: false,
};

const calendarSlice = createSlice({
    name: CALENDAR_SLICE_NAME,
    initialState: calendarInitialState,
    reducers: {
        calendarDatesChanged: (state) => {
            state.areDatesVisible = true;
        },
        timesAreUserSelected: (state, { payload: isSelected }) => {
            state.areTimesSelected = isSelected;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(BOOKING_RESTARTED, () => calendarInitialState);
        builder.addCase(CLEAR_TIMES, (state) => ({ ...state, areTimesSelected: false }));
    },
});

export const { calendarDatesChanged, timesAreUserSelected } = calendarSlice.actions;

export const { reducer: calendarReducer } = calendarSlice;

const getCalendarConfiguration = (state: ApplicationState) => state[moduleId][CALENDAR_SLICE_NAME];

export const areDatesVisible = flow(
    getCalendarConfiguration,
    (calendarConfiguration) => calendarConfiguration.areDatesVisible
);

export const isTimeSelected = flow(
    getCalendarConfiguration,
    (calendarConfiguration) => calendarConfiguration.areTimesSelected
);
